module.exports = __webpack_public_path__ + "ProximaNova-f8f52169aea2273f310c8ba2970cb85f.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/fonts/ProximaNova.svg
// module id = 167
// module chunks = 1